import React from 'react';
import { Constants } from '../../Constants';

const EnterAchDetailsSection = (props) =>{
    return (
        <div className="row m-1 p-1">
            <div className="col-sm-12 col-md-6 p-2">
            <div className="card border border-muted p-1">
                    {/* Max and min lenghts and other validation elements specified at https://api.authorize.net/xml/v1/schema/AnetApiSchema.xsd 
                    Check the asp.net core backend for details about mapping, validation is duplicated on the backend */}
                    <h3>Billing Address</h3>
                    <label className="control-label"  htmlFor="fname"><i className="fa fa-user" style={{"color": "grey"}}></i> First Name</label>
                    <input className="form-control" type="text" id="fname" name="firstName" required maxLength={50} autoComplete="given-name"/>
                    <label className="control-label"  htmlFor="lname"> Last Name</label>
                    <input className="form-control" type="text" id="lname" name="lastName" required maxLength={50} autoComplete="family-name"/>
                    <label className="control-label"  htmlFor="company"> Company Name <span className="text-muted">(Optional)</span></label>
                    <input className="form-control" type="text" id="company" name="company" maxLength={50} autoComplete="organization" />
                    <label className="control-label"  htmlFor="billingEmail"><i className="fa fa-envelope" style={{"color":"grey"}}></i> Email</label>
                    <input type="email" className="form-control" type="text" id="billingEmail" name="email" required maxLength={255} autoComplete="email"/>
                    <label className="control-label"  htmlFor="adr"><i className="fa fa-address-card-o" style={{"color":"grey"}}></i> Address</label>
                    <input className="form-control" type="text" id="adr" name="address" required maxLength={60} autoComplete="street-address"/>
                    <label className="control-label"  htmlFor="city"><i className="fa fa-institution" style={{"color":"grey"}}></i> City</label>
                    <input className="form-control" type="text" id="city" name="city" required maxLength={40} placeholder=""/>
                    <div className="row">
                        <div className="col-6">
                            <label className="control-label"  htmlFor="state">State</label>
                            <select className="form-select" type="text" id="state" name="state" required maxLength={40}>
                                {Constants.unitedStatesList.map(
                                    (val, index) => <option key={index} value={val}>{val}</option>
                                )}
                            </select>
                        </div>
                        <div className="col-6">
                            <label className="control-label"  htmlFor="zip">Zip</label>
                            <input className="form-control" type="text" id="zip" name="zip" required maxLength={20} autoComplete="postal-code"/>
                        </div>
                    </div>
                    <label className="control-label" htmlFor="country">Country</label>
                    <input className="form-control readOnly" readOnly value="United States" type="text" id="country" 
                        name="country" required maxLength={60}/>
                </div>
            </div>
            
            <div className="col-sm-12 col-md-6 p-2">
                <h3>ACH details</h3>                
                <label className="control-label"  htmlFor="rnumber">Routing Number</label>
                <input className="form-control" type="text" id="rnumber" name="routingNumber" required maxLength={150} placeholder=""/>
                <label className="control-label"  htmlFor="bankNumber">Bank account number</label>
                <input className="form-control" type="text" id="bankNumber" name="bankAccountNumber" required maxLength={150} placeholder=""/>                
            </div>
            
        </div>
    )
}
export { EnterAchDetailsSection }; 